import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const Safety = () =>{
    return(
        <>
            <Row className="justify-content-center">
                <Col lg={8} md={10} sm={12} className="contain pd">
                    <div className="text1"> <h3> HEALTH, SAFETY, SECURITY AND ENVIRONMENT (HSE) POLICY STATEMENT </h3></div>
                    <div className="text3" > SAMCO is committed to ensuring that all business is conducted in accordance with the highest health, 
                        safety, security and environmental standard.to ensure that these standards are met our company expects as a 
                        condition of employment for corporate and contractor personnel and as a condition of contractual 
                        agreement everywhere. 
                        The Company will communicate this Policy and make it available to its employees, partners, suppliers. and 
                        with the communities in which it operates. </div><br/>
                    <div className="text2" > Our Company strives for excellence in health, safety, societal commitment, security and environment through:  </div><br/>
                    <ul>
                        <li className="text3">
                        Leadership and allocation of resources to conduct and maintain safe, healthy, secure, socially,environmentally responsible operations </li><br/>
                        <li className="text3">
                        Provision of safe and healthy work environment free from harm to all personnel and surrounding communities</li><br/>
                        <li className="text3">
                        Protect, prevent damage and minimize disturbance to environmentally, ecologically, 
                        archeologically and socially sensitive areas</li><br/>
                        <li className="text3"> Empowering all employees to stop work in the event of potentially unsafe acts and conditions and 
                        to immediately report such unsafe acts and conditions </li><br/>
                        <li className="text3">  Respect to national, regional and local traditions, religious beliefs and cultures as well as dialogue
                        with local communities  </li><br/>
                        <li className="text3"> Vigilant management of waste in all areas of operations </li><br/>
                        <li className="text3"> Continuous improvement of our HSE Management Systems in order to ensure sustainable future 
                        of our Company, partners, employees and environment </li><br/>
                    </ul>
                </Col>
                <hr className="h-r"/>
            </Row>
            
           
           

            </>
    )
}
export default Safety